"use client";
import React, { Fragment } from "react";
import Image, { StaticImageData } from "next/image";
import { Heading, Icon, Circle, Text, Stack, HStack } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import { HEADING_VARIANTS } from "@/theme/components/heading";
import { IconType } from "@onemind-services-llc/react-icons-ng";

export type CardProps = {
  content?: React.ReactNode;
  icon?: IconType;
  image?: string | StaticImageData;
  subTitle?: string;
  title: string;
};

const Card = (props: CardProps) => {
  const { content, icon, image, subTitle, title } = props;
  const textVariant = useTextVariants();

  return (
    <Stack
      borderWidth={"1px"}
      borderColor={"primary.300"}
      backgroundColor={"white"}
      borderRadius={"32px"}
      className="brand-shadow"
      p={6}
      pl={{ base: 6, md: 8 }}
      spacing={6}
      w={"100%"}
    >
      <HStack spacing={4}>
        {icon && (
          <Circle
            size="52px"
            border="2px solid"
            borderColor="primary.200"
            color="primary.200"
          >
            <Icon as={icon} w={8} h={8} />
          </Circle>
        )}
        {image && (
          <Image alt={title} src={image} style={{ height: "auto", width: "48px" }} />
        )}
        <Heading as="h1" variant={HEADING_VARIANTS.SUBTITLE1} fontWeight={600}>
          {title}
        </Heading>
      </HStack>
      <Stack height={"100%"} justifyContent={"space-between"}>
        {subTitle && (
          <Text color="text.100" fontWeight={600} variant={textVariant}>
            {subTitle}
          </Text>
        )}
        {content && (
          <Fragment>
            {typeof content === "string" ? (
              <Text variant={textVariant} color={"text.100"}>
                {content}
              </Text>
            ) : (
              content
            )}
          </Fragment>
        )}
      </Stack>
    </Stack>
  );
};

export default Card;
